var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs"},_vm._l((_vm.options),function(data,index){return _c('router-link',{key:index,attrs:{"to":({name: data.route})}},[_vm._v("\n      "+_vm._s(data.name)+"\n    ")])}),1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }